export const PRODUCTION_LEAD_DAYS = 30;

export const productionLeadDays = (opp) => {
    if (!opp?.production_date || !opp?.delivery_date) return null;
    const p = new Date(opp.production_date);
    const d = new Date(opp.delivery_date);
    p.setHours(0, 0, 0, 0);
    d.setHours(0, 0, 0, 0);
    return Math.round((d - p) / 86400000);
};

export const isProductionLate = (opp) => {
    const days = productionLeadDays(opp);
    return days !== null && days < PRODUCTION_LEAD_DAYS;
};
